import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {IddTraining} from '../../../shared/interface/idd-training';

export enum ChartType {
  HalfDoughnut = 'half_doughnut',
  Horizontal = 'horizontal'
}

@Component({
  selector: 'app-idd-training-chart',
  templateUrl: './idd-training-chart.component.html',
  styleUrls: ['./idd-training-chart.component.scss']
})
export class IddTrainingChartComponent implements OnChanges {
  readonly halfDoughnutChartType = ChartType.HalfDoughnut;
  readonly horizontalChartType = ChartType.Horizontal;

  @Input() iddTraining: IddTraining;
  @Input() chartType: ChartType;

  totalRequiredMinutes = 0;
  realisedAssetsInPercent = 0;
  realisedLifeInPercent = 0;
  realisedGeneralInPercent = 0;
  realisedInPercent = 0;

  ngOnChanges(): void {
    this.totalRequiredMinutes =
      this.iddTraining.requiredAssetsMinutes +
      this.iddTraining.requiredLifeMinutes +
      this.iddTraining.requiredGeneralMinutes
    ;
    this.realisedAssetsInPercent = (100 * (this.iddTraining.requiredAssetsMinutes - this.iddTraining.leftAssetsMinutes)
      / this.iddTraining.requiredAssetsMinutes);
    if (this.realisedAssetsInPercent > 100) {
      this.realisedAssetsInPercent = 100;
    }

    this.realisedLifeInPercent = (100 * (this.iddTraining.requiredLifeMinutes - this.iddTraining.leftLifeMinutes)
      / this.iddTraining.requiredLifeMinutes);
    if (this.realisedLifeInPercent > 100) {
      this.realisedLifeInPercent = 100;
    }
    this.realisedGeneralInPercent = (100 * (this.iddTraining.requiredGeneralMinutes - this.iddTraining.leftGeneralMinutes)
      / this.iddTraining.requiredGeneralMinutes);
    if (this.realisedGeneralInPercent > 100) {
      this.realisedGeneralInPercent = 100;
    }

    this.realisedInPercent = 100
      * (Math.min((this.iddTraining.requiredAssetsMinutes - this.iddTraining.leftAssetsMinutes), this.iddTraining.requiredAssetsMinutes)
        + Math.min((this.iddTraining.requiredLifeMinutes - this.iddTraining.leftLifeMinutes), this.iddTraining.requiredLifeMinutes) +
      Math.min((this.iddTraining.requiredGeneralMinutes - this.iddTraining.leftGeneralMinutes), this.iddTraining.requiredGeneralMinutes)
    ) / this.totalRequiredMinutes;
  }

  floor(num: number): number {
    return Math.floor(num);
  }
}
